const SIZE = 400;
const C = SIZE / 2;
const RING = SIZE * 0.34;
const R = SIZE * 0.058;

export const BraceletPreview = ({ beads = [], onBead, className = "" }) => (
  <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className={`w-full h-auto ${className}`} data-testid="bracelet-preview" role="img" aria-label="Bracelet preview">
    <defs>
      <radialGradient id="bead-shine" cx="35%" cy="30%" r="65%">
        <stop offset="0" stopColor="#fff" stopOpacity=".75" />
        <stop offset=".35" stopColor="#fff" stopOpacity=".12" />
        <stop offset="1" stopColor="#000" stopOpacity=".35" />
      </radialGradient>
    </defs>
    <circle cx={C} cy={C} r={RING} fill="none" stroke="#e9d5ff" strokeOpacity=".35" strokeWidth="1.5" />
    {beads.map((color, i) => {
      const a = (2 * Math.PI * i) / beads.length - Math.PI / 2;
      const x = C + RING * Math.cos(a);
      const y = C + RING * Math.sin(a);
      return (
        <g key={i} onClick={onBead ? () => onBead(i) : undefined} data-testid={onBead ? `designer-bead-${i}` : undefined}
          className={onBead ? "cursor-pointer [&:hover>circle]:opacity-90" : ""}>
          <circle cx={x} cy={y} r={R} fill={color} style={{ transition: "fill 300ms" }} />
          <circle cx={x} cy={y} r={R} fill="url(#bead-shine)" pointerEvents="none" />
        </g>
      );
    })}
  </svg>
);
